import { render } from "./p-phone-number.vue?vue&type=template&id=0959140e&scoped=true"
import script from "./p-phone-number.vue?vue&type=script&lang=js"
export * from "./p-phone-number.vue?vue&type=script&lang=js"

import "./p-phone-number.vue?vue&type=style&index=0&id=0959140e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0959140e"]])

export default __exports__